"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import styled from "styled-components";

const StyledLabel = styled(LabelPrimitive.Root)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #4b4f58;
  font-size: 0.875rem; /* text-sm */
  font-weight: 500;
  line-height: 1;
  user-select: none;

  &[data-disabled="true"],
  .group[data-disabled="true"] & {
    pointer-events: none;
    opacity: 0.5;
  }

  .peer:disabled + &,
  .peer[aria-disabled="true"] + & {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

function Label({
  className,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return <StyledLabel data-slot="label" className={className} {...props} />;
}

export { Label };
